<template>
  <div class="pg-color-mix">
    <div class="pg-color-mix__item">
      <p>颜色一</p>
      <ColorPicker size="medium " v-model="firstColor" />
      <p>{{ firstColor }}</p>
    </div>
    <div class="pg-color-mix__item">
      <p>颜色二</p>
      <ColorPicker size="medium " v-model="secondColor" />
      <p>{{ secondColor }}</p>
    </div>
    <div class="pg-color-mix__item">
      <p>比例</p>
      <InputNumber :min="0" :max="1" :step="0.1" v-model="radio" />
    </div>
    <div class="pg-color-mix__result">
      <p>混合后的颜色</p>
      <div class="pg-color__mix-color" :style="{ background: color }"></div>
      <p>{{ color }}</p>
    </div>
  </div>
</template>
<script setup>
import { ColorPicker, InputNumber } from 'element-ui'
import { ref, computed } from 'vue'
import { colorBlend } from '../../../utils/index'

const firstColor = ref('#FFFFFF')
const secondColor = ref('#000000')
const radio = ref(0)

const color = computed(() => colorBlend(firstColor.value, secondColor.value, radio.value))
</script>

<style lang="scss">
@import '../style/color-mix.scss';
</style>
